import type { JSX } from "react";

import { Trans } from "@lingui/react";
import { Loader } from "@mobsuccess-devops/react-ui/Loader";

import { useUnsafeQueryNavbar } from "../../public/services/user/navbar";

type EnsureUserProps = {
  children: JSX.Element;
};

export function EnsureUser({ children }: EnsureUserProps): JSX.Element {
  const query = useUnsafeQueryNavbar();

  if (query.isLoading) {
    return (
      <Loader.Block>
        <Loader.Ellipsis />
        <Loader.Description>
          <Trans id="ensure-user.loading-user-infos" />
        </Loader.Description>
      </Loader.Block>
    );
  }

  if (query.isError) {
    return (
      <Loader.Block>
        <Loader.Ellipsis />
        <Loader.Description>
          <Trans id="ensure-user.error-loading-user-infos" />
        </Loader.Description>
      </Loader.Block>
    );
  }

  return children;
}
